// extracted by mini-css-extract-plugin
module.exports = {"test":"Test_test__2NJI2"};